import Vue from "vue";

/**
 * Event bus system for Vue component cross-communication.
 */
export const eventBus = new Vue();

export interface IModalPayload {
  component: string;
}
